import { useEffect, useState } from 'react'

import { ISelectOption } from '../../../components/Select'
import { useAppToast } from '../../../helpers'
import { JobPositionService } from '../../../services/JobPosition/JobPositionService'
import { JobPosition } from '../../../services/JobPosition/types'
import { SectorService } from '../../../services/Sector/SectorService'

/** Roles (for the role picker, with sector and status) and sectors, for the filters and the sheet. */
export function useEmployeeOptions() {
  const toast = useAppToast()
  const [roles, setRoles] = useState<JobPosition[]>([])
  const [sectors, setSectors] = useState<ISelectOption<number>[]>([])

  useEffect(() => {
    new SectorService()
      .listForSelect()
      .then((list) => setSectors(list.map((sector) => ({ value: sector.id, label: sector.name }))))
      .catch((error) => toast.error('Erro ao carregar os setores', error))
    new JobPositionService()
      .listAll()
      .then(setRoles)
      .catch((error) => toast.error('Erro ao carregar os cargos', error))
  }, [toast])

  const roleOptions: ISelectOption<number>[] = roles.map((role) => ({ value: role.id, label: role.name }))

  return { roles, sectors, roleOptions }
}
